import { CollaborationMetricsResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

export const getCollaborationMetrics = async (
  orgId: string,
): Promise<CollaborationMetricsResponse> => {
  const response = await apiRequest<CollaborationMetricsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/collaboration`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch collaboration metrics');
  }

  return response.data;
};
